import React from "react";
import { createRoot } from "react-dom/client";
import "./styles/main.css";
import App from "./App";

const container = document.getElementById("root");
const root = window.__FORTRESS_REACT_ROOT__ || createRoot(container);

window.__FORTRESS_REACT_ROOT__ = root;

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
